"use strict";

var React = require('react/addons'),
    ReactRouter = require('react-router'),
    DocumentTitle = require('react-document-title'),
    cx = require('classnames'),
    BS = require('react-bootstrap'),
    Constants = require('../../constants'),
    ToolboxSidebar = require('./Sidebar'),
    Header = require('./Header'),
    Footer = require('./Footer'),
    CurrentUser = require('../../shared/CurrentUser'),
    Link = require('../../components/Link'),
    ReactShare = require('react-share'),
    SB = ReactShare.ShareButtons,
    Clipboard = require('../../external/clipboard'),
    toastr = require('toastr');

var ToolboxWidgets = React.createClass({displayName: "ToolboxWidgets",

    contextTypes: {
        router: React.PropTypes.func
    },

    render: function() {
        var me = this,
            props = me.props,
            state = me.state,
            data = props.project.toJSON(),
            query = {
                API: this.context.router.getCurrentQuery().API
            },
            widgetCode = [
                '<a href="', data.websiteRedirect, '" target="_blank">',
                '<img src="', data.image, '" border="0" style="max-width: 100%">',
                '</a>'
            ].join(''),
            title = props.title + ' - Widgets';

        return (
             React.createElement("div", {className: "wrapper"}, 
                React.createElement(DocumentTitle, {title: title}), 
                React.createElement(Header, {project: props.project, builder: props.builder}), 
                React.createElement("div", {className: "container content"}, 
                    React.createElement("div", {className: "row"}, 
                        React.createElement(ToolboxSidebar, {project: props.project, showContactForm: true}), 
                        React.createElement("div", {className: "col-sm-9"}, 
                            React.createElement("h1", null, "Get Widget"), 
                            React.createElement("p", {className: "margin-bottom-10"}, 
                                "Below are widgets that include your personalized Agent Tracker Link to help you to easily market ", React.createElement("span", {className: "blue-text"}, data.name), " to your buyers. If you need technical help, please click on the “Help” button on the right side of the page."
                            ), 

                            React.createElement(BS.Panel, {className: "margin-bottom-10 panel-no-header", header: (React.createElement("h2", {className: "orange-text"}, "Image Widget:"))}, 
                                React.createElement("p", {className: "margin-bottom-10"}, 
                                    "The Image Widget is a widget contains the image below with your" + ' ' + 
                                    "Agent Tracker link. Copy and paste the code in the box into the HTML" + ' ' + 
                                    "or source view of your website."
                                ), 

                                React.createElement("p", {className: "margin-bottom-10 orange-text font-bold"}, 
                                    "NOTE: Widget only work when added to web pages."
                                ), 

                                React.createElement(BS.Input, {readOnly: true, type: "textarea", rows: "4", groupClassName: "margin-bottom-10", className: "orange-border", value: widgetCode}), 
                                Constants.canClipboardCopy && (
                                    React.createElement("div", {className: "btn-u btn-u-ultra-narrow btn-u-orange margin-bottom-10", onClick: this.copyToClipboard.bind(null, widgetCode)}, "Copy Code to Clipboard")
                                ), 

                                React.createElement("p", {className: "margin-bottom-10"}, "Preview of Widget:"), 

                                React.createElement("a", {href: data.websiteRedirect, target: "_blank"}, 
                                    React.createElement("img", {src: data.image, border: "0", style: { maxWidth: '100%'}})
                                )
                            ), 

                            React.createElement(BS.Panel, {className: "margin-bottom-10 panel-no-header", header: (React.createElement("h2", {className: "orange-text"}, "Your Agent Tracker Link:"))}, 
                                React.createElement("p", {className: "margin-bottom-10"}, 
                                    "Below is your personalized Agent Tracker link to market ", React.createElement("span", {className: "blue-text"}, data.name), ". You can use" + ' ' + 
                                    "this link in any of your electronic marketing such as on websites, emails, social media, etc.."
                                ), 

                                React.createElement(BS.Input, {readOnly: true, type: "text", groupClassName: "margin-bottom-0", className: "orange-border", value: data.websiteRedirect}), 

                                React.createElement("div", {className: "share-wrap margin-top-20"}, 
                                    React.createElement("h2", {className: "panel-title orange-text"}, "Automatically market on Social Media:"), 
                                    React.createElement("p", null, "Click on a logo to post your Agent Tracker Link on: "), 
                                    React.createElement("div", {className: "share-icons"}, 
                                        React.createElement(SB.FacebookShareButton, {title: data.name, url: data.websiteRedirect}, React.createElement("img", {src: Constants.imageRoot + 'social/ShareButton_Facebook_35x35.png'})), 
                                        React.createElement(SB.LinkedinShareButton, {title: data.name, url: data.websiteRedirect}, React.createElement("img", {src: Constants.imageRoot + 'social/ShareButton_LinkedIn_35x35.png'})), 
                                        React.createElement(SB.TwitterShareButton, {title: data.name, url: data.websiteRedirect}, React.createElement("img", {src: Constants.imageRoot + 'social/ShareButton_Twitter_35x35.png'}))
                                    )
                                )
                            )
                        )
                    ), 
                    React.createElement(Footer, {trackerId: "agent-toolbox-widgets"})
                )
            )
        );
    },

    copyToClipboard: function(valueToCopy) {
        Clipboard.copy(valueToCopy);
        toastr.success('Copied to Clipboard!');
    }
});
module.exports = ToolboxWidgets;
